import React, { Fragment, useState } from "react";

import { useCompleteConversation } from "../../../hooks/mbts-ux";

interface IChatCompletionWindowProps {
    visible: boolean;
    conversationId: string;
    scenarioId: string | null;
    messageThreshold: 'level1' | 'level2' | null;
    nextOperation: 'next-persona' | 'analysis' | null;
    nextPersonaDetails: { personaId: string } | null;
    onStayInConversation: () => void;
};
export const ChatCompletionWindow = (props: IChatCompletionWindowProps) => {
    const { visible, conversationId, scenarioId, messageThreshold, nextOperation, nextPersonaDetails, onStayInConversation } = props;

    const [isProcessing, setIsProcessing] = useState<boolean>(false);

    const { mutate: completeConversation } = useCompleteConversation();

    const handleNext = () => {
        if (!scenarioId || !nextOperation) return;

        completeConversation({
            conversationId,
            scenarioId,
            setIsProcessing,
            nextOperation,
            nextPersonaDetails,
        });
    };

    const canStayInConversation = messageThreshold !== 'level2';

    return (
        <div className={`mbts_chat__conversation_completion_window ${visible ? 'mbts_chat__conversation_completion_window--visible' : ''}`}>
            <div className='card card--md card--radius-md mbts_chat__conversation_completion_window__content'>
                <p className='text-2xl text-bold color--primary text-center mb-lg'>Your conversation analysis is ready</p>
                <p className='color--txt-muted text-center'>
                    {
                        canStayInConversation
                            ? 'You can choose to end the conversation or continue till you achieve your goal.'
                            : 'Thank you for completing the conversation. You can now proceed with the next persona.'
                    }
                </p>
                <div className='mbts_chat__conversation_completion_window__actions'>
                    <button className='btn btn--fluid btn--md btn--radius-md btn--primary' onClick={handleNext}>
                        {isProcessing
                            ? <span className='btn-loader' />
                            : <Fragment>
                                {nextOperation === 'analysis' ? <span>Go&nbsp;to&nbsp;Analysis</span> : !!nextPersonaDetails ? <span>Next&nbsp;Persona</span> : <span>Go&nbsp;to&nbsp;Overview</span>}
                            </Fragment>
                        }
                    </button>
                    {canStayInConversation &&
                        <button className='btn btn--fluid btn--md btn--radius-md btn--secondary' onClick={onStayInConversation}>
                            Stay&nbsp;in&nbsp;Conversation
                        </button>
                    }
                </div>
            </div>
        </div>
    );
};
